import Vue from 'vue'
import Vuex from 'vuex'
import { login, smsLogin, wecomLogin, getUserInfo, logout } from '@/api/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    menus: JSON.parse(localStorage.getItem('menus') || '[]'),
    permissions: JSON.parse(localStorage.getItem('permissions') || '[]')
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    menus: state => state.menus,
    permissions: state => state.permissions,
    username: state => state.userInfo.username || '',
    realName: state => state.userInfo.realName || '',
    userId: state => state.userInfo.userId || null,
    roles: state => state.userInfo.roles || [],
    isCompanyManager: state => {
      const roles = state.userInfo.roles || []
      return roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_DIRECTOR')
    },
    isAdmin: state => {
      const roles = state.userInfo.roles || []
      return roles.includes('ROLE_ADMIN')
    },
    isDirector: state => {
      const roles = state.userInfo.roles || []
      return roles.includes('ROLE_DIRECTOR')
    },
    isProjectManager: state => {
      const roles = state.userInfo.roles || []
      return roles.includes('ROLE_PROJECT_MANAGER')
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))
    },
    SET_MENUS(state, menus) {
      state.menus = menus
      localStorage.setItem('menus', JSON.stringify(menus))
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
      localStorage.setItem('permissions', JSON.stringify(permissions))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.userInfo = {}
      state.menus = []
      state.permissions = []
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('menus')
      localStorage.removeItem('permissions')
    }
  },
  actions: {
    async login({ commit }, loginForm) {
      const res = await login(loginForm)
      return commitLoginResult(commit, res)
    },
    async loginBySms({ commit }, smsForm) {
      const res = await smsLogin(smsForm)
      return commitLoginResult(commit, res)
    },
    async loginByWecom({ commit }, code) {
      const res = await wecomLogin(code)
      return commitLoginResult(commit, res)
    },
    async getUserInfo({ commit }) {
      const res = await getUserInfo()
      const data = res.data
      commit('SET_USER_INFO', {
        userId: data.userId,
        username: data.username,
        realName: data.realName,
        avatar: data.avatar,
        roles: data.roles || []
      })
      commit('SET_MENUS', data.menus || [])
      commit('SET_PERMISSIONS', data.permissions || [])
      return res
    },
    async logout({ commit }) {
      try {
        await logout()
      } catch (e) {
        // ignore
      }
      commit('CLEAR_AUTH')
    }
  }
})

// 密码/短信登录成功后统一写入认证状态
function commitLoginResult(commit, res) {
  const data = res.data
  commit('SET_TOKEN', data.token)
  commit('SET_USER_INFO', {
    userId: data.userId,
    username: data.username,
    realName: data.realName,
    avatar: data.avatar,
    roles: data.roles || []
  })
  commit('SET_MENUS', data.menus || [])
  return res
}
